import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './TextInput.scss';

const TextInput = forwardRef(
  ({ error, icon, defaultValue, className, ...others }, ref) => {
    const classes = `textInput ${className}`;
    return (
      <div className={classes}>
        {icon && icon}
        <input
          className={classNames('inputBox', {
            inputError: error,
            iconDivider: !!icon,
          })}
          type="text"
          {...others}
          ref={ref}
        />
        {error && (
          <>
            <i className="fa fa-exclamation-triangle errorIcon" />
            <span className="errorText">{error}</span>
          </>
        )}
      </div>
    );
  },
);

TextInput.propTypes = {
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.string,
  icon: PropTypes.node,
};

TextInput.defaultProps = {
  defaultValue: '',
};

export default TextInput;
